import { motion } from 'framer-motion';

export default function TermsPage() {
  return (
    <div className="page-transition" data-testid="terms-page">
      <section className="py-16 md:py-24 bg-muted/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl md:text-5xl font-serif font-semibold text-foreground mb-8">
              Terms & Conditions
            </h1>
            <p className="text-muted-foreground mb-4">Last updated: March 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-serif font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground mb-6">
              By accessing and using the Artisan Market & Studio website and services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">2. Description of Services</h2>
            <p className="text-muted-foreground mb-6">
              Artisan Market & Studio provides a platform for artisans to showcase and sell their handmade goods, educational resources through AMS University, business tools through AMS Compass, and event coordination through AMS Events. We reserve the right to modify or discontinue any service at any time.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">3. Vendor Membership</h2>
            <p className="text-muted-foreground mb-6">
              Vendor membership is subject to approval. All vendors must agree to sell only handmade, artisan goods. Resale items are strictly prohibited. Vendors are responsible for the quality and safety of their products and must comply with all applicable laws and regulations.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">4. Event Participation</h2>
            <p className="text-muted-foreground mb-6">
              Participation in AMS Events is subject to availability and approval. Event fees, booth assignments, and participation guidelines will be communicated prior to each event. Cancellation policies vary by event and will be specified in event-specific agreements.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">5. Intellectual Property</h2>
            <p className="text-muted-foreground mb-6">
              All content on this website, including text, graphics, logos, and images, is the property of The Motley Maker LLC or its content suppliers and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">6. User Conduct</h2>
            <p className="text-muted-foreground mb-6">
              Users agree to use our services only for lawful purposes. You may not use our platform to transmit harmful, offensive, or illegal content. We reserve the right to terminate access for any user who violates these terms.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">7. Limitation of Liability</h2>
            <p className="text-muted-foreground mb-6">
              Artisan Market & Studio and The Motley Maker LLC shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for our services.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">8. Indemnification</h2>
            <p className="text-muted-foreground mb-6">
              You agree to indemnify and hold harmless The Motley Maker LLC, its officers, directors, employees, and agents from any claims, damages, or expenses arising from your use of our services or violation of these terms.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">9. Changes to Terms</h2>
            <p className="text-muted-foreground mb-6">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of our services constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">10. Contact Information</h2>
            <p className="text-muted-foreground mb-6">
              For questions about these Terms & Conditions, please contact us at{' '}
              <a href="mailto:info@artisanmarketandstudio.com" className="text-primary hover:underline">
                info@artisanmarketandstudio.com
              </a>
            </p>

            <div className="mt-12 p-6 bg-muted/50 rounded-xl">
              <p className="text-sm text-muted-foreground">
                © 2026 The Motley Maker LLC. All Rights Reserved. Artisan Market & Studio is a trademark of The Motley Maker LLC.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
